export const ClassCategories = {
    getAll: async () => {
      try {
        return new Promise((resolve, reject) => {
          let methodType = 'GET';
          let headers = {
            'Accept': 'application/json',
          };
          let body = null;
          window
            .fetch(`https://95n7rvx8t4.execute-api.us-east-1.amazonaws.com/Prod/categories/`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
              mode: 'cors',
          })
            .then(response => {
              if ((response.status >= 200) && (response.status <= 299)) {
                return response.json().then(resolve);
              } else {
                return reject(response);
              }
            })
            .catch(e => {
                return reject(e);
            });
        });
      } catch (error) {
        return error;
      }
    },
  };
  